// @ts-nocheck
import { ExternalProviderLinkModel } from "@insite/client-framework/Services/IdentityService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import signInExternalProvider from "@insite/client-framework/Store/Context/Handlers/SignInExternalProvider";
import loadExternalProviders from "@insite/client-framework/Store/Pages/SignIn/Handlers/LoadExternalProviders";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import FormActions, { FormActionsProps } from "@store/Components/Toolkit/FormActions";
import { spacingStyles } from "@store/Themes/common/mixins/spacing";
/* Starter Custom Code - End */

const enum fields {
    fullWidthButton = "fullWidthButton",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.fullWidthButton]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    externalProviders: state.pages.signIn.externalProviders,
});

const mapDispatchToProps = {
    loadExternalProviders,
    signInExternalProvider,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SignInExternalProvidersStyles {
    divider?: InjectableCss;
    titleText?: TypographyPresentationProps;
    providerButton?: ButtonPresentationProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
    formActions?: FormActionsProps;
}

export const signInExternalProvidersStyles: SignInExternalProvidersStyles = {
    wrapper: {
        css: spacingStyles("1em", null),
    },
    titleText: {
        variant: "p",
        forwardAs: "h3",
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.bold};
        `,
    },
    formActions: {
        spacing: "1em",
    },
    providerButton: { variant: "tertiary" },
};

const styles = signInExternalProvidersStyles;

const SignInExternalProviders = ({
    externalProviders,
    loadExternalProviders,
    signInExternalProvider,
    fields,
}: Props) => {
    useEffect(() => {
        if (!externalProviders) {
            loadExternalProviders();
        }
    }, [externalProviders]);

    const providerButtonClickHandler = (externalProvider: ExternalProviderLinkModel) => {
        signInExternalProvider({ externalProvider });
    };

    if (!externalProviders || externalProviders.length === 0) {
        return null;
    }

    // Starter Removed - providerButtonCss

    return (
        <StyledWrapper {...styles.wrapper} /* Starter Custom Code */>
            <Typography {...styles.titleText} /* Starter Removed - "as" */>
                {translate("Use another service to log in.")}
            </Typography>
            <FormActions {...styles.formActions} fullWidth={fields.fullWidthButton} /* Starter Custom Code */>
                {externalProviders.map(externalProvider => (
                    <Button
                        {...styles.providerButton}
                        // Starter Removed - providerButtonCss
                        key={externalProvider.caption}
                        onClick={() => providerButtonClickHandler(externalProvider)}
                    >
                        {externalProvider.caption}
                    </Button>
                ))}
            </FormActions>
        </StyledWrapper>
    );
};

const Divider = styled.hr`
    ${styles.divider?.css}
`;

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SignInExternalProviders),
    definition: {
        allowedContexts: ["SignInPage", "SignInOverlay"],
        group: "Sign In",
        displayName: "External Providers",
        fieldDefinitions: [
            {
                name: fields.fullWidthButton,
                displayName: "Full Width Button",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 0,
            },
        ],
    },
};

export default widgetModule;
